import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Button from 'react-bootstrap-button-loader';
import { SspApi, SessionApi } from '../../../api';
import { setLoader, removeLoader } from '../../../actions';

import {
  InputField,
  required,
  email,
  ifNotBlank,
  passwordBlank,
  matchField
} from '../../../components/form';

class Form extends Component {

  onFormSubmit(values) {
    const { dispatch, user } = this.props;
    dispatch(setLoader('SspForm'));
    dispatch(SspApi.actions.meUpdate.post(values, (error, success) => {
      dispatch(removeLoader('SspForm'));
      if (success) {
        dispatch({
          type: SessionApi.events.user.actionSuccess,
          syncing: false,
          data: { ...user, name: success.data.name, company: success.data.company }
        });

        dispatch({
          type: SspApi.events.me.actionSuccess,
          syncing: false,
          data: { data: success.data }
        });
      }
    }));
  }

  render() {
    const { handleSubmit, isLoading } = this.props;

    return (
      <form
        onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
      >
        <div>
          <Field
            type='text'
            name='ssp[name]'
            placeholder='Your full name'
            label='Name'
            component={InputField}
            validate={[required]}
          />

          <Field
            type='text'
            name='ssp[email]'
            placeholder='Your email address'
            label='Email'
            disabled
            component={InputField}
            validate={[required, email]}
          />

          <Field
            type='text'
            name='ssp[company]'
            placeholder='Name of your company'
            label='Company'
            component={InputField}
            validate={[required]}
          />

          <Field
            type='password'
            name='ssp[current_password]'
            placeholder='Current password'
            label='Current Password'
            component={InputField}
            validate={[ifNotBlank('password', 'ssp')]}
          />

          <Field
            type='password'
            name='ssp[password]'
            placeholder='New Password'
            label='Password'
            component={InputField}
            validate={[passwordBlank]}
          />

          <Field
            type='password'
            name='ssp[password_confirmation]'
            placeholder='Confirm Password'
            label='Confirm Password'
            component={InputField}
            validate={[matchField('password', 'ssp')]}
          />

        </div>

        <div className='m-t-md text-right'>
          <Button
            type='submit'
            loading={isLoading}
            bsStyle='primary'
          >
            Update
          </Button>
        </div>
      </form>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'SspForm'
});


const mapStateToProps = (state, ownProps) => {
  const { loader, user } = state;
  const isLoading = loader.includes('SspForm');
  const ssp = ownProps.ssp;
  const initialValues = {
    ssp: {
      name: ssp.name,
      email: ssp.email,
      company: ssp.company
    }
  };

  return { isLoading, initialValues, user: user.data };
};

export default connect(mapStateToProps)(ResourceForm(Form));
